import { useLingui } from '@lingui/react';
import { GqlFiscalYear } from '../graphql/base-types.graphql';
import { fiscalYearDisplay } from './fiscal-year';

export const FiscalYearDisplay = ({ fiscalYear }: { fiscalYear: GqlFiscalYear }) => {
  const { i18n } = useLingui();

  return <span style={{ whiteSpace: 'nowrap' }}>{fiscalYearDisplay(fiscalYear, i18n.locale)}</span>;
};
